import { __assign, __rest } from "tslib";
import React from 'react';
import { Link } from '@fluentui/react';
import { HighlightFilterText } from '../../../../../';
import { valueOrDefaultColumnRenderer } from '../../../../Utilities';
export var DataGridColumnLinkBase = function (props) {
    var _a;
    var text = props.text, highlightText = props.highlightText, searchAriaLabel = props.ariaLabel, dataGridColumnStyle = props.dataGridColumnStyle, dataGridColumnProcessedStyle = props.dataGridColumnProcessedStyle, otherProps = __rest(props, ["text", "highlightText", "ariaLabel", "dataGridColumnStyle", "dataGridColumnProcessedStyle"]);
    return (React.createElement("div", { "data-testid": "DataGridColumnLink", className: String(dataGridColumnProcessedStyle.leftAlignedCellContainer) },
        React.createElement(Link, __assign({}, otherProps, { styles: __assign(__assign({}, props.styles), { root: [
                    dataGridColumnStyle.fontProperties,
                    dataGridColumnStyle.linkColor,
                    dataGridColumnStyle.alignLeft,
                    (_a = props.styles) === null || _a === void 0 ? void 0 : _a.root
                ] }) }), highlightText ? (React.createElement(HighlightFilterText, { fullText: text || '', searchText: highlightText.split(' '), searchAriaLabel: searchAriaLabel })) : (valueOrDefaultColumnRenderer(text)))));
};
//# sourceMappingURL=DataGridColumnLink.base.js.map